'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import TrackIntroductionInformationContainer from '../../containers/TrackPage/TrackIntroductionInformationContainer';

const TrackIntroductionPage = ({
  track
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(StoredContentContainer, {
    contentId: track.get('introVideo'),
    trackId: track.get('id'),
    trackName: track.get('name')
  }), /*#__PURE__*/_jsx(TrackIntroductionInformationContainer, {
    track: track
  })]
});

TrackIntroductionPage.propTypes = {
  track: ImmutablePropTypes.map.isRequired
};
export default TrackIntroductionPage;